import { getLbtcAddressConfig } from '@lombard.finance/sdk';
import { CURRENT_ENV } from 'modules/common/const';
import { OChainId, TChainId } from '../chainIDs';
import { OLstToken, TLstToken } from '../tokens';

const lbtcConfig = getLbtcAddressConfig(CURRENT_ENV);

type TTokenAddress = {
  [key in TLstToken]: string;
};

export type NetworkConfig = TTokenAddress;

type TEvmConfig = {
  [key in TChainId]?: NetworkConfig;
};

const prodConfig: TEvmConfig = {
  [OChainId.ethereum]: {
    [OLstToken.LBTC]: lbtcConfig[OChainId.ethereum],
    [OLstToken.eBTC]: '0x657e8c867d8b37dcc18fa4caead9c45eb088c642',
  },
  [OChainId.sonic]: {
    [OLstToken.LBTC]: lbtcConfig[OChainId.sonic],
    [OLstToken.eBTC]: '0x657e8c867d8b37dcc18fa4caead9c45eb088c642',
  },
};

export const DUMMY_CONFIG: NetworkConfig = {
  [OLstToken.LBTC]: '',
  [OLstToken.eBTC]: '',
};

export const getEvmConfig = (env = CURRENT_ENV): TEvmConfig => {
  switch (env) {
    case 'prod':
    default:
      return prodConfig;
  }
};
